import { render, staticRenderFns } from "./table-assigned-processes.vue?vue&type=template&id=36bc93d8&scoped=true&"
import script from "./table-assigned-processes.vue?vue&type=script&lang=js&"
export * from "./table-assigned-processes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bc93d8",
  null
  
)

export default component.exports